import type { Release } from '../releases';

export default {
  id: '2026-11-01-site-on-time',
  at: '2026-11-01T05:59:00Z',
  title: 'Площадка: доля отчётов, сданных вовремя, и напоминание до срока',
  modules: ['site'],
  items: [
    'На странице «Не сдали отчёт смены» появился блок «Сдано вовремя за период»: какая доля участко-дней сдана до срока, сколько сдано поздно и не сдано — по проектам и по дням, рядом цель 90 %. Считаются рабочие дни по календарю графика, на которые выдан участок.',
    'Срок каждого дня — тот час сдачи, что действовал в этот день. Если час поменять после срока, новый час действует с завтрашнего дня: прошлые дни не пересчитываются.',
    'За два часа до срока прорабу в «Ждёт меня» приходит напоминание «Сдайте отчёт смены до 20:00»; после срока, как и раньше, — просроченное дело ему и сводка руководителю.',
    'В сводке дня есть кнопка «Текст Pilot»: Pilot пересказывает сводку связным текстом. Если Pilot не подключён или не ответил, остаётся текст по цифрам и видно почему.',
  ],
  why: 'Руководитель видел только, кто не сдал отчёт сегодня, и не мог понять, насколько дисциплинированно площадка сдаёт отчёты за месяц, — а это главный показатель пилота по площадке.',
  link: '/site/missing',
} satisfies Release;
